<script>
    export let abbr;
    export let lastname;

    export let disabled = false;
    export let required = false;

    // const abbrs = ['Mr.', 'Dr.', 'Miss', 'Mrs.', 'Ms.', 'Rabbi', 'Bishop', 'Father', 'Sir', 'Capt.'];
    const abbrs = ['Mr', 'Sir', 'Mrs', 'Miss'];

</script>

<div class="lastname-control">
    <select class="form-select abbr" bind:value="{ abbr }" {disabled} {required}>
        <option value="" disabled>Select...</option>
        {#each abbrs as item}
            <option value="{ item }">{ item }</option>
        {/each}
    </select>
    <input type="text" class="form-control lastname" bind:value="{ lastname }" {disabled} {required}>
</div>

<style>
    .lastname-control {
        display: flex;
    }

    .lastname-control .abbr {
        width: 90px;
        font-size: 0.8rem;
        letter-spacing: -1px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
        padding-left: 8px;
        padding-right: 0;
    }

    .lastname-control .lastname {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
</style>